import { createConsola } from "consola";
import { ENV_DEVELOPMENT_ID } from "../constants/environments";
import { DEBUG_LEVEL, WARN_LEVEL } from "./consolaLogLevels";
import plainConsoleReporter from "./plainConsoleReporter";
/**
 * Consola log levels: 0 = fatal/error, 1 = warn, 2 = log, 3 = info, 4 = debug, 5 = trace.
 * We show messages at configured level and below (numerically).
 * Keyed by basicAppConfig.mode (BuildType).
 */
const ENV_LOG_LEVEL = {
    local: DEBUG_LEVEL,
    development: DEBUG_LEVEL,
    production: WARN_LEVEL,
};
/**
 * Creates a root consola instance with level derived from env, default tag from appId,
 * and config attached on defaults for reporters (appId, platform, appVersion, etc.).
 *
 * `reporters` replaces Consola's default BrowserReporter, whose `%c` badge and
 * CSS argument are stored literally by TrackJS. See `plainConsoleReporter`.
 */
export default function createAppLogger(config) {
    const level = ENV_LOG_LEVEL[config.env] ?? ENV_LOG_LEVEL[ENV_DEVELOPMENT_ID];
    const instance = createConsola({
        level,
        reporters: [plainConsoleReporter],
        defaults: {
            tag: config.appId,
            ...config,
        },
    });
    return instance;
}
